import { render } from "./index.vue?vue&type=template&id=01d0ee62&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=01d0ee62&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=1&id=01d0ee62&lang=scss"

import exportComponent from "/data/samsungshop/nps-prd/web/questionnaire/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d0ee62"]])

export default __exports__